import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from '@angular/platform-browser';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
})
export class AppComponent {

	eventBusSub?: Subscription;

	constructor(private matIconRegistry: MatIconRegistry,
				private domSanitizer: DomSanitizer) {
		this.matIconRegistry.addSvgIcon("twitter", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/img/icons/twitter.svg"));
		this.matIconRegistry.addSvgIcon("facebook", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/img/icons/facebook.svg"));
		this.matIconRegistry.addSvgIcon("whatsapp", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/img/icons/whatsapp.svg"));
	}
}
